import { render } from "./uil-file-alt.vue?vue&type=template&id=5413baa8"
import script from "./uil-file-alt.vue?vue&type=script&lang=js"
export * from "./uil-file-alt.vue?vue&type=script&lang=js"
script.render = render

export default script